import React from "react";
import {MenuComponent} from "../components/MenuComponent";
import {CardComponent} from "../components/CardComponent";
import {Query} from "@apollo/client/react/components";
import {
    Box, Chip,
    FormHelperText,
    Skeleton,
    Typography
} from "@mui/material";
import {withRouter} from "../services/withRouter";
import {LinkCustomComponent} from "../components/LinkCustomComponent";
import * as emoji from "node-emoji";

import printService from "../services/printService";
import GET_CANDIDATE_RELEASE from "../querys/queryCandidateRelease";

class ReleaseCandidateComponentPure extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            indexTab: 0
        };
    }

    render() {
        return (
            <>
                <MenuComponent/>
                <header className="content">
                    <CardComponent style={{width: '800px'}}>
                        <Query query={GET_CANDIDATE_RELEASE}
                               variables={{idCandidateRelease: this.props.params.idCandidateRelease}}>
                            {({data, loading, error}) => {
                                if (loading) {
                                    return (
                                        <Box sx={{width: '800px'}}>
                                            <Skeleton animation="wave"/>
                                            <Skeleton animation="wave"/>
                                            <Skeleton animation="wave"/>
                                            <Skeleton animation="wave"/>
                                            <Skeleton animation="wave"/>
                                            <Skeleton animation="wave"/>
                                        </Box>
                                    )
                                } else if (error) {
                                    return (
                                        <>
                                            <FormHelperText error={true} style={{textAlign: "center"}}>
                                                {error.message}
                                            </FormHelperText>

                                        </>
                                    )
                                } else if (data) {
                                    let createdAt = new Date(parseInt(data.getReleaseCandidate.created_at));
                                    createdAt = createdAt.toLocaleDateString('pt-BR', {timeZone: 'UTC'});

                                    let description = 'Sem descrição';
                                    if (data.getReleaseCandidate.description) {
                                        description = data.getReleaseCandidate.description.replace(/\*/g, "<br />");
                                        description = emoji.emojify(description);
                                    }

                                    return (
                                        <>
                                            <Typography variant="h4" component="h5" textAlign={"left"}>
                                                Candidato de Release {data.getReleaseCandidate.name} - {data.getReleaseCandidate.module.name} - {data.getReleaseCandidate.module.product.name}
                                            </Typography>
                                            <br/>
                                            <Typography variant="subtitle1" component="subtitle2" textAlign={"left"}>
                                                Criado em: {createdAt} -
                                                <LinkCustomComponent to={'./'}
                                                                     onClick={() => printService.print(
                                                                         `Versão ${data.getReleaseCandidate.name} - ${data.getReleaseCandidate.module.name} - ${data.getReleaseCandidate.module.product.name}`,
                                                                         description)}>
                                                    Imprimir
                                                </LinkCustomComponent>
                                            </Typography>
                                            <br/>
                                            <div style={{backgroundColor: '#F1F3F4', padding: 10}}>
                                                <Typography variant="subtitle1" component="subtitle2"
                                                            textAlign={"left"}>
                                                    <td dangerouslySetInnerHTML={{__html: description}}/>
                                                </Typography>
                                            </div>

                                            <br/><br/>

                                            <Typography variant="subtitle1" component="subtitle2" textAlign={"left"}>
                                                Sprint: <LinkCustomComponent
                                                to={`/sprints/${data.getReleaseCandidate.sprint.id}`}>
                                                <Chip clickable={true} label={data.getReleaseCandidate.sprint.name} color="primary"/>
                                            </LinkCustomComponent>
                                            </Typography>

                                            <br/>

                                            <Typography variant="subtitle1" component="subtitle2" textAlign={"left"}>
                                                Módulo: <LinkCustomComponent
                                                to={`/modules/${data.getReleaseCandidate.module.id}`}>
                                                <Chip clickable={true} label={data.getReleaseCandidate.module.name} color="primary"/>
                                            </LinkCustomComponent>
                                            </Typography>

                                            <br/>

                                            <Typography variant="subtitle1" component="subtitle2" textAlign={"left"}>
                                                Produto:
                                                <LinkCustomComponent
                                                    to={`/products/${data.getReleaseCandidate.module.product.id}`}>
                                                    <Chip clickable={true} label={data.getReleaseCandidate.module.product.name}
                                                          color="primary"/>
                                                </LinkCustomComponent>
                                            </Typography>
                                        </>
                                    )
                                }
                            }}
                        </Query>
                    </CardComponent>
                </header>
            </>
        );
    }
}

export const ReleaseCandidateComponent = withRouter(ReleaseCandidateComponentPure);
